import React from 'react';
import ReactMarkdown from 'react-markdown';
import { BotMessageSquare } from 'lucide-react';

const Message = ({ message, isLastBotMessage }) => {
  if (message.sender === "user") {
    return (
      <div className="flex justify-end mb-4">
        <div className="max-w-[80%] px-4 py-2 rounded-lg bg-blue-500 text-white">
          {message.text}
        </div>
      </div>
    );
  }

  return (
    <div className="flex mb-4">
      <div className="flex items-start pt-2 mr-2" style={{ width: "28px", flexShrink: 0 }}>
        <BotMessageSquare className="text-blue-500" size={28} />
      </div>
      <div className="flex-grow px-4 py-2 rounded-lg text-gray-800">
        <ReactMarkdown className="markdown">
          {message.text}
        </ReactMarkdown>
      </div>
    </div>
  );
};

export default Message;